import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../ReduxToolkit/Hooks';
import { setCreatedData } from '../../../../ReduxToolkit/Reducers/ProjectSlice';
import { Form, Formik, ErrorMessage, Field } from 'formik';
import { Col, FormGroup, Label, Row } from 'reactstrap'
import { lockerInitialValue, lockerValidation } from '../../../../Data/Application/ProjectList/ProjectList';
import { LockerInitialValue } from '../../../../Types/Application/ProjectList/ProjectList';
import ButtonSection from '../ProjectCreate/ButtonSection';
import api from '../../../../utils/api';
import Swal from 'sweetalert2';

const CreateNewLockerForm = () => {
    const navigate = useNavigate();
    const { createdFormData } = useAppSelector((state) => state.project);
    const dispatch = useAppDispatch();
  
    const projectSubmit = async (values: LockerInitialValue) => {
      const submittedData = {
        lockerId: 0,
        lockerNumber: values.title,
        lockerType: values.locker_size,
        lockerPrice: values.locker_price,
        securityCharges: values.securityCharges,
        isLocked: false
      };
      if (!submittedData.lockerNumber || !submittedData.lockerType || !submittedData.lockerPrice || !submittedData.securityCharges) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Please fill all the required fields.',
        });
        return; // Stop submission if validation fails
      }
      if (String(submittedData.lockerNumber).trim() === "") {
        Swal.fire("Error!", "Locker number cannot be empty.", "error");
        return;
      }
      if (isNaN(Number(submittedData.lockerPrice)) || Number(submittedData.lockerPrice) <= 0) {
        Swal.fire("Error!", "Please enter a valid locker price.", "error");
        return;
      }
      if (isNaN(Number(submittedData.securityCharges)) || Number(submittedData.securityCharges) < 0) {
        Swal.fire("Error!", "Please enter a valid security charge.", "error");
        return;
      }
      dispatch(setCreatedData([...createdFormData, submittedData]));
      try {
        const response = await api.post('/api/LockerMaster/AddLocker', submittedData, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
    
        if (response.status === 200 || response.status === 201) {
          dispatch(setCreatedData([...createdFormData, response.data]));
          if(response.data.messege === null){
            Swal.fire({
              icon: 'success',
              title: 'Success!',
              text: 'Locker Created successfully.',
            }).then(() => {
              navigate(`${process.env.PUBLIC_URL}/locker/lockerList`);
            });
          }else{
            Swal.fire({
              icon: 'error',
              title: 'Error!',
              text: 'This Locker number already exists.',
            });
          }
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Unexpected Response',
            text: 'Please try again later.',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Submission Failed',
          text: 'Something went wrong while creating the locker.',
        });
      }
    };
    return (
      <Formik initialValues={lockerInitialValue} validationSchema={lockerValidation} onSubmit={projectSubmit}>
        {() => (
          <Form className="theme-form">
            <Row>
                <Col sm="4">
                <FormGroup>
                    <Label check>Locker Number</Label>
                    <Field name="title" type="text" className="form-control" placeholder="Enter locker number here..." />
                    <ErrorMessage name="title" component="span" className="text-danger" />
                </FormGroup>
                </Col>
                <Col sm="4">
                    <FormGroup>
                        <Label check>Locker Size</Label>
                        <Field name="locker_size" as="select" className="form-control form-select">
                        <option value=" ">Select Locker</option>
                        <option value="Small Locker">Small Locker</option>
                        <option value="Big Locker">Big Locker</option>
                        </Field>
                    </FormGroup>
                </Col>
                <Col sm="4">
                <FormGroup>
                    <Label check>Locker Price</Label>
                    <Field name="locker_price" className="form-control" type="text" placeholder="Enter per locker price here..." />
                    <ErrorMessage name="locker_price" component="span" className="text-danger" />
                </FormGroup>
                </Col>
                <Col sm="4">
                <FormGroup>
                    <Label check>Security Charge</Label>
                    <Field name="securityCharges" className="form-control" type="text" placeholder="Enter per security charge here..." />
                    <ErrorMessage name="securityCharges" component="span" className="text-danger" />
                </FormGroup>
                </Col>
            </Row>
            <ButtonSection cancel_url={`/locker/lockerList`} />
          </Form>
        )}
      </Formik>
    )
}

export default CreateNewLockerForm